export default "__VITE_ASSET__Bk8DyFPx__"